import Route from '@core/components/Route';
import { RoutePath } from '@core/types/route';
import { ReactElement } from 'react';

export const ALEXANDER_SOLOVEV_PROSA: (ReactElement | string)[] = [
  <>
    Gründer und Leiter von <Route href={RoutePath.SolovevStyle}>Solovev Style</Route>
  </>,
  <>
    8. Großmeistergrad in <Route href={RoutePath.KampfkunstRanking}>Solovev Defense</Route>
  </>,
  'Begann mit Kampfkunst schon im Kindesalter',
  'Erster Unterricht durch Vater und Großvater, beide Offiziere von Spezialeinheiten der russischen Armee',
  'Weiteres Training während der militärischen Ausbildung und in Spezialeinheiten',
  'Studierte verschiedene russische Kampfkünste und lies sie in seinen Stil einfließen',
  'Praktische Erfahrung im Kampf gegen organisierte Kriminalität und beim Zoll',
  'Seine Ausbildung hat mehreren seiner Schüler bereits das Leben gerettet',
];
